// Keep realtime receipts newer than in-flight HTTP snapshots. This cache is
// local to one mounted inbox; the server remains authoritative for counts.
export const createStaffUnreadState = (messageLimit = 10000) => {
  const seen = new Map();
  const counts = new Map();
  let version = 0;
  const messageKey = message => message?.conversation_id && message?.id
    ? `${message.conversation_id}|${message.id}` : null;
  const remember = message => {
    const key = messageKey(message);
    if (!key) return;
    const read = seen.get(key) === true || message.read_by_staff === true;
    seen.delete(key);
    seen.set(key, read);
    if (seen.size > messageLimit) seen.delete(seen.keys().next().value);
  };
  return {
    version: () => version,
    rememberMessages: messages => (messages || []).forEach(remember),
    acceptMessage(message) {
      const key = messageKey(message);
      const fresh = Boolean(key && !seen.has(key));
      remember(message);
      return fresh && message.sender_role === 'player' && message.read_by_staff !== true;
    },
    confirmRead(roomId, ids) {
      (ids || []).forEach(id => remember({ conversation_id: roomId, id, read_by_staff: true }));
    },
    count: (roomId, fallback = 0) => counts.get(roomId)?.count ?? (Number(fallback) || 0),
    update(roomId, count) {
      if (!roomId || !Number.isInteger(count) || count < 0) return false;
      counts.set(roomId, { count, version: ++version });
      return true;
    },
    snapshot(room, startedAt) {
      const latest = counts.get(room.id);
      if (latest && latest.version > startedAt) return { ...room, staff_unread: latest.count };
      const count = Number(room.staff_unread);
      if (Number.isInteger(count) && count >= 0) counts.set(room.id, { count, version });
      return room;
    },
    changedSince: (roomId, startedAt) => (counts.get(roomId)?.version || 0) > startedAt,
  };
};

export const confirmedStaffUnread = response => {
  const count = response?.staff_unread;
  if (response?.ok === false || count === undefined || count === null
    || !Number.isInteger(Number(count)) || Number(count) < 0) {
    throw new Error('Invalid read acknowledgement');
  }
  return Number(count);
};
